import React from 'react';
import { Input } from './Input';

export function DateInput({
  value,
  onChange,
  placeholder = '',
  ariaLabel,
  inputRef,
  className = '',
  ...rest
}) {
  return (
    <Input
      type="date"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      ariaLabel={ariaLabel}
      inputRef={inputRef}
      className={className}
      {...rest}
    />
  );
}
